import React, {useCallback} from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import {useSeatingPlanStore} from "../../api/SeatingPlanStore";
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";

export function StatusQuoButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    const refreshSeatingPlans = useSeatingPlanStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        return refreshSeatingPlans();
    }, [refreshSeatingPlans]);

    return currentOfficeId !== null ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${currentOfficeId}/create-status-quo-seating-plan`}
            description="Generate a Status Quo seating plan from the current office layout."
            actionButtonLabel="Status Quo"
            variant="outlined"
            icon={<AutoAwesomeIcon/>}
            onFinish={handleFinish}
        />
    ) : null;
}
